import dynamic from 'next/dynamic';

export interface LiveFiltersModalProps {
  title: string;
  resetLabel: string;
  dismissModalLabel: string;
  setOn: (_: boolean) => void;
}

export const LiveFiltersModal = dynamic<LiveFiltersModalProps>(
  () => import('features/live/liveFiltersModal/LiveFiltersModal').then((mod) => mod.LiveFiltersModal),
  {
    ssr: false,
  }
);
